import React from "react";
import { TextField, MenuItem } from "@mui/material";
import { getIn } from "formik";

class TextfieldWrapper extends React.Component {
  handleChange = (value) => {
    const { name, onChange } = this.props;
    onChange(name, value.target.value);
  };

  handleBlur = () => {
    const { name, onBlur } = this.props;
    if (onBlur) {
      onBlur(name, true);
    }
  };

  render() {
    const { options, touched, errors, name, value, ...attributes } = this.props;
    const err = getIn(errors, name);
    const touch = getIn(touched, name);

    const configTextfield = {
      ...attributes,
      fullWidth: true,
      select: true,
      variant: "outlined",
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      helperText: touch && err ? err : null,
    };

    return (
      <TextField {...configTextfield}>
        {Object.keys(options).map((item, pos) => {
          if (options[item].Iso) {
            const { Iso } = options[item];
            options[item] = Iso;
          }
          console.log(options[item]);
          return (
            <MenuItem key={pos} value={item}>
              {options[item]}
            </MenuItem>
          );
        })}
      </TextField>
    );
  }
}

export default TextfieldWrapper;
